__turbopack_context__.v({
  "caption_label": "Calendar-module-scss-module__mUdDOG__caption_label",
  "cell": "Calendar-module-scss-module__mUdDOG__cell",
  "day": "Calendar-module-scss-module__mUdDOG__day",
  "day-range-end": "Calendar-module-scss-module__mUdDOG__day-range-end",
  "day_disabled": "Calendar-module-scss-module__mUdDOG__day_disabled",
  "day_hidden": "Calendar-module-scss-module__mUdDOG__day_hidden",
  "day_outside": "Calendar-module-scss-module__mUdDOG__day_outside",
  "day_range_middle": "Calendar-module-scss-module__mUdDOG__day_range_middle",
  "day_selected": "Calendar-module-scss-module__mUdDOG__day_selected",
  "head_cell": "Calendar-module-scss-module__mUdDOG__head_cell",
  "head_row": "Calendar-module-scss-module__mUdDOG__head_row",
  "month": "Calendar-module-scss-module__mUdDOG__month",
  "month_caption": "Calendar-module-scss-module__mUdDOG__month_caption",
  "months": "Calendar-module-scss-module__mUdDOG__months",
  "nav": "Calendar-module-scss-module__mUdDOG__nav",
  "row": "Calendar-module-scss-module__mUdDOG__row",
  "table": "Calendar-module-scss-module__mUdDOG__table",
});
